export class StaysRepository {
    driver;
    constructor(driver) {
        this.driver = driver;
    }
    /** Pull-side: replace the snapshot wholesale (small table, self-healing). */
    async replaceAll(rows) {
        await this.driver.batch([
            { sql: 'DELETE FROM stay_snapshots' },
            ...rows.map((s) => ({
                sql: `INSERT INTO stay_snapshots (id, folio_no, room_number, guest_name, status, as_of)
              VALUES (?, ?, ?, ?, ?, ?)`,
                params: [s.id, s.folioNo, s.roomNumber, s.guestName, s.status, s.asOf],
            })),
        ]);
    }
    async listInHouse() {
        const rows = await this.driver.query({
            sql: `SELECT * FROM stay_snapshots WHERE status = 'IN_HOUSE' ORDER BY room_number`,
        });
        return rows.map(mapRow);
    }
    async getById(id) {
        const rows = await this.driver.query({
            sql: 'SELECT * FROM stay_snapshots WHERE id = ?',
            params: [id],
        });
        return rows[0] ? mapRow(rows[0]) : null;
    }
}
function mapRow(r) {
    return {
        id: String(r.id),
        folioNo: String(r.folio_no),
        roomNumber: r.room_number == null ? null : String(r.room_number),
        guestName: String(r.guest_name),
        status: String(r.status),
        asOf: String(r.as_of),
    };
}
//# sourceMappingURL=stays.js.map